import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ParameterDetailsState } from './types';
import { fetchParameterDetailsAsync, fetchParameterDetailsAsyncBuilder } from './asyncRequest';
import { TestParameter } from '../waterTestStrip/types';

const initialState: ParameterDetailsState = {
  data: null,
  selectedParameter: null,
  loading: false,
  error: null,
  status: 'idle'
};

const parameterDetailsSlice = createSlice({
  name: 'parameterDetails',
  initialState,
  reducers: {
    setSelectedParameter: (state, action: PayloadAction<TestParameter | null>) => {
      state.selectedParameter = action.payload;
    },
    resetParameterDetails: (state) => {
      state.data = null;
      state.loading = false;
      state.error = null;
      state.status = 'idle';
    }
  },
  extraReducers: (builder) => {
    fetchParameterDetailsAsyncBuilder(builder);
  }
});

export const ParameterDetailsActions = {
  ...parameterDetailsSlice.actions,
  fetchParameterDetailsAsync
};

export const parameterDetailsReducer = parameterDetailsSlice.reducer;